<div class="d-flex gap-2">
  <app-sidebar></app-sidebar>

  <div class="flex-grow-1 content">
    <router-outlet></router-outlet>
  </div>
</div>
